var React = require('react');

function ContextMenuArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.9998 4.46806C11.3334 4.78041 11.3334 5.30427 10.9998 5.61662L6 10.25L1.00021 5.61662C0.666598 5.30427 0.666597 4.78041 1.00021 4.46806C1.31074 4.17731 1.79815 4.17731 2.10868 4.46806L6 8.0636L9.89132 4.46806C10.2019 4.17731 10.6893 4.17731 10.9998 4.46806Z","fill":"#E8EFFF"})));
}

ContextMenuArrowDown.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 13","fill":"none"};

module.exports = ContextMenuArrowDown;

ContextMenuArrowDown.default = ContextMenuArrowDown;
